import { formatPhoneNumberIntl } from 'react-phone-number-input';

export default (number: string) => {
  const numberFormatted = formatPhoneNumberIntl(number);
  const nrSplits = numberFormatted.split(' ');

  return nrSplits[0] + ' (' + nrSplits[1] + ') ' + nrSplits[2] + '-' + nrSplits[3];
};
